import { Action } from 'redux';
import { delay } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import { RootState } from 'types/store';
import { getType } from 'typesafe-actions';

import * as actions from './actions';

function* handleChangeRules(action: Action & { payload: number }) {
  const state: RootState = yield select();
  const currentIndex = state.rules.index;
  if (action.payload !== currentIndex) {
    yield put(actions.setOpacity(false));
    yield delay(250);
    yield put(actions.setOpacity(true));
    yield put(actions.changeRules(action.payload));
  }
}

function* watchChangeRulesRequests() {
  yield takeEvery(getType(actions.requestChangeRules), handleChangeRules);
}

export default function*() {
  yield watchChangeRulesRequests();
}



// WEBPACK FOOTER //
// ./src/store/modules/rules/saga.ts